const navLinks = document.querySelectorAll('.top-level-button');
const navDropdowns = document.querySelectorAll('.nav__dropdown');
const navItems = document.querySelectorAll('.nhsuk-header__navigation-item');

// Helper function to close all dropdowns and remove active states
function closeAllDropdowns() {
    navDropdowns.forEach(dropdown => {
        dropdown.classList.remove('nav__dropdown--active');
        dropdown.setAttribute('aria-hidden', 'true');
    });

    navItems.forEach(item => {
        item.classList.remove('active');
        const buttons = item.querySelectorAll('button[aria-expanded]');
        buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
    });
}

// Helper function to open a specific dropdown
function openDropdown(parentItem, dropdown, button) {
    parentItem.classList.add('active');
    dropdown.classList.add('nav__dropdown--active');
    dropdown.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
}

// Toggle dropdown on nav link click
navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();

        const parentItem = link.closest('.nhsuk-header__navigation-item');
        const dropdown = parentItem.querySelector('.nav__dropdown');
        const isCurrentlyOpen = parentItem.classList.contains('active');

        closeAllDropdowns();

        if (!isCurrentlyOpen) {
            openDropdown(parentItem, dropdown, link);
        }
    });
});

// Close dropdowns when clicking outside
document.addEventListener('click', (e) => {
    if (!e.target.closest('.nhsuk-header__navigation-item')) {
        closeAllDropdowns();
    }
});

// Close dropdowns when escape key is pressed
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        closeAllDropdowns();
    }
});